import { withAsync } from '@/components'
import type { RouteConfig } from 'react-router-config'
import PersonalAuth from '@/components/PersonalAuth'

const routes: RouteConfig[] = [
  {
    path: '/wallet',
    component: PersonalAuth,
    routes: [
      {
        name: 'wallet',
        path: '/',
        component: withAsync(() => import(/* webpackChunkName: "Wallet" */ '@/containers/Wallet')),
        exact: true,
        main: true,
      },
      {
        name: 'preemptBalance',
        path: '/preemptBalance',
        component: withAsync(() => import(/* webpackChunkName: "PreemptBalance" */ '@/containers/Wallet/PreemptBalance')),
        exact: true,
      },
      {
        name: 'recordList',
        path: '/recordList',
        component: withAsync(() => import(/* webpackChunkName: "PreemptBalance" */ '@/containers/Wallet/RecordList')),
        exact: true,
      },
      {
        name: 'pay',
        path: '/pay',
        component: withAsync(() => import(/* webpackChunkName: "PreemptBalance" */ '@/containers/Wallet/Pay')),
        exact: true,
      },
    ],
  },
]

export default routes
